import React from 'react';
import CreatableSelect from 'react-select/creatable';
import './select.scss';

const index = ({ errors = {}, isClearable, options, setting={}, value, onChange, onInputChange = () => {}, onBlur, disabled }) => {
  
  let errorMessage = "";

  if(errors.pattern){
    errorMessage = setting.patternMessage ? setting.patternMessage : "Invalid Value";
  }
  else if(errors.required){
    errorMessage = "This field is required";
  }

  const isError = Object.keys(errors).length > 0;

  const customStyles = {
    control: (provided) => ({
      ...provided,
      fontSize: '13px',
      borderColor: !isError ? '#e8ebf3' : '#dc3545', // Set the border color to grey

    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '13px',
      //   color: state.isSelected ? '#857e7e' : provided.color,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#857e7e',
    }),
  };
  return (
    <>
      <CreatableSelect
        isClearable={isClearable}
        options={options}
        defaultValue={value}
        value={value}
        className={!isError ? '' : 'has-error'}
        onChange={onChange}
        onInputChange={onInputChange}
        onBlur={onBlur}
        isDisabled={disabled}
        styles={customStyles}
      />
      {isError ? (
        <span className="error-message">{errorMessage}</span>
      ) : (
        ''
      )}
    </>
  );
};

export default index;
